<template>
    <div class="ah-page special-project-edit-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1 v-if="!form.sno">新增特定費用項目</h1>
                        <h1 v-if="form.sno">編輯特定費用項目</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <el-form ref="form" :rules="rules" :model="form" label-width="180px" label-position="right">
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">特定費用設定</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item label="年份">
                            <el-select v-model="form.yer" placeholder="請選擇年份">
                                <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="nam" label="特定費用項目名稱">
                            <el-input v-model="form.nam" style="max-width: 400px" :maxlength="50" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item prop="sdt" label="起始日">
                            <el-date-picker v-model="form.sdt" type="date" value-format="timestamp" placeholder="選擇日期"> </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="edt" label="結案日">
                            <el-date-picker v-model="form.edt" type="date" value-format="timestamp" placeholder="選擇日期"> </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="expiredCannotClaim" label="請款限制">
                            <el-radio-group v-model="form.expiredCannotClaim">
                                <el-radio :label="true">期間範圍內才可請款</el-radio>
                                <el-radio :label="false">不限制</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item prop="amt" label="總預算">
                            <div>
                                <el-select v-model="form.cny" prop="cny" style="width: 100px; margin-right: 6px" no-data-text="無資料" placeholder="幣別">
                                    <el-option :label="item.cnynam" :value="item.cny" v-for="item in currencyList" :key="item.sno"></el-option>
                                </el-select>
                                <MoneyInput v-model="form.amt" :precision="form.cny == 'TWD' ? 0 : 2" style="width: 240px" />
                                <span v-if="form.cny != 'TWD'" style="border: 1px solid #ddd; color: #888; background-color: #fbfbfb; padding: 11px 15px; margin-left: 6px; border-radius: 5px">
                                    <span>約當台幣：</span>
                                    <Money :v="amtInTwd" /> 元
                                </span>
                            </div>
                        </el-form-item>
                        <el-form-item label="審核流程">
                            <div class="flow-editor">
                                <div class="flow-item">
                                    <span class="num">1</span>
                                    <span class="name">申請人</span>
                                </div>
                                <draggable v-model="form.auditFlowItems" draggable=".editable" animation="300">
                                    <div
                                        v-for="(element, index) in form.auditFlowItems"
                                        :key="index"
                                        :class="{
                                            'flow-item': element.menU_UNT != 'ADD',
                                            add_item: element.menU_UNT == 'ADD',
                                            editable: element.typ === 0,
                                        }"
                                    >
                                        <el-button class="add-btn primary-action" round plain type="primary" v-if="element.menU_UNT === 'ADD'" icon="el-icon-plus" @click="addFlowMember(index)"
                                            >新增審核人</el-button
                                        >
                                        <p v-else-if="element.typ === 1">
                                            <span class="num">{{ index + 1 }}</span>
                                            <span class="name">
                                                <span v-if="element.menU_UNT == 'B02'">開立</span>
                                                <span v-else-if="element.menU_UNT == 'B03'">入帳</span>
                                                <span v-else-if="element.menU_UNT == 'A02'">填寫付款明細</span>
                                                <span v-else-if="element.menU_UNT == 'A03'">確認付款</span>
                                                <span v-else>{{ element.menU_UNT }}</span>
                                            </span>
                                        </p>
                                        <div v-else>
                                            <span class="num">{{ index + 2 }}</span>
                                            <el-select v-model="element.value" placeholder="請選擇" @change="(value) => handleMemberSelect(value, index)">
                                                <el-option-group v-for="group in memberSelections" :key="group.label" :label="group.label">
                                                    <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                                                </el-option-group>
                                            </el-select>
                                            <el-button class="del-btn" @click="deleteItem(index)"><i class="el-icon-delete"></i></el-button>
                                        </div>
                                    </div>
                                </draggable>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <center>
                    <el-button type="normal" @click="onCancel">取消</el-button>
                    <el-button type="primary" @click="handleSubmit" class="primary-action">送出</el-button>
                </center>
            </el-form>
        </div>
    </div>
</template>
<script>
import draggable from 'vuedraggable';

export default {
    components: {
        draggable,
    },
    props: {
        inputObject: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            yearList: [],
            form: {
                sno: null,
                yer: null,
                nam: '',
                sdt: null,
                edt: null,
                cny: 'TWD',
                auditFlowItems: [],
                sP_FLAG: 1,
                expiredCannotClaim: false,
            },
            rules: {
                nam: [
                    {
                        required: true,
                        message: '請輸入名稱',
                        tigger: 'blur',
                    },
                ],
                sdt: [
                    {
                        type: 'number',
                        required: true,
                        message: '請選擇預計起始日',
                        tigger: 'change',
                    },
                ],
                edt: [
                    {
                        type: 'number',
                        required: true,
                        message: '請選擇預計結案日',
                        tigger: 'change',
                    },
                ],
                amt: [
                    {
                        type: 'number',
                        required: true,
                        message: '請輸入總預算',
                        tigger: 'blur',
                    },
                ],
            },
            memberSelections: [],
            defaultAuditFlowItems: {},
        };
    },
    created() {
        this.fetchAuditStaffOptions();
        this.fetchDefaultFlow(() => {
            if (this.$route.params.sno) {
                this.fetchData();
            }
        });

        const THIS_YEAR = new Date().getFullYear();
        for (let i = THIS_YEAR + 1; i >= THIS_YEAR - 10; i -= 1) {
            this.yearList.push({ value: i, label: i });
        }
    },
    computed: {
        amtInTwd() {
            return this.form.amt * this.getCnyRat(this.form.cny);
        },
        currencyList() {
            return this.$store.getters['cny/cnyOptions'];
        },
    },
    methods: {
        getCnyRat(cny) {
            const cnyOption = this.currencyList.find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
        // 取得審核人列表
        fetchAuditStaffOptions() {
            this.$api({
                url: '/CurrentExpenditureSettingPage/GetAuditStaffOptions',
                method: 'GET',
            }).then((resp) => {
                console.log('Audit Staff Options', resp.data);

                // 製作結構
                this.memberSelections = [
                    {
                        label: '職位',
                        options: [
                            {
                                value: '1/主管',
                                sno: 0,
                                label: '申請人主管',
                            },
                        ],
                    },
                    {
                        label: '指定人員',
                        options: resp.data.options
                            .filter((o) => o.grP_NO !== 'OT1')
                            .filter((o) => o.grP_NO !== 'OT2')
                            .filter((o) => o.grP_NO !== 'OT3')
                            .filter((o) => o.grP_NO !== 'OT4')
                            .map((x) => ({
                                value: `2/${x.sno}/${x.nam}`,
                                sno: x.sno,
                                label: x.nam,
                            })),
                    },
                ];
            });
        },
        fetchData() {
            this.$api({
                url: `/SpecialProjectManagementPage/GetProjectDetail?Sno=${this.$route.params.sno}`,
                method: 'GET',
            }).then((resp) => {
                this.form = resp.data.item;
                console.log('SpecialProject detail', resp.data.item);

                // 去掉第一個 "menU_UNT":"ADD" "A2" "A3" 的物件（申請人, 付款, 確認付款)
                // 剩下是與 defulat 流程不同的物件
                let addedFlowItems = resp.data.item.auditFlowItems.filter((x) => x.menU_UNT !== 'ADD' && x.menU_UNT !== 'A02' && x.menU_UNT !== 'A03');

                // 加入 value 欄位供下拉式選單用
                addedFlowItems = addedFlowItems.map((x) => ({
                    ...x,
                    value: x.rolE_TYP === 1 ? '1/主管' : `2/${x.elsE_STF_SNO}/${x.menU_UNT}`,
                }));

                // 將 流程不同的物件 插入到 default 的申請人之下
                const AddItem = this.defaultAuditFlowItems.find((x) => x.menU_UNT === 'ADD');
                const A02Item = this.defaultAuditFlowItems.find((x) => x.menU_UNT === 'A02');
                const A03Item = this.defaultAuditFlowItems.find((x) => x.menU_UNT === 'A03');
                let allFlow = [];
                allFlow.push(AddItem);
                allFlow = allFlow.concat(addedFlowItems);
                allFlow.push(A02Item);
                allFlow.push(A03Item);

                this.form.auditFlowItems = allFlow;

                // this.form.auditFlowItems = this.form.auditFlowItems.map((x) => {
                //     return {
                //         ...x,
                //         value: x.rolE_TYP === 1 ? `1/主管` : `2/${x.elsE_STF_SNO}/${x.menU_UNT}`,
                //     };
                // });
            });
        },
        fetchDefaultFlow(callback) {
            this.$api({
                url: '/SpecialProjectManagementPage/GetDefaultAuditFlow',
                method: 'GET',
            }).then((resp) => {
                this.defaultAuditFlowItems = resp.data.auditFlowItems;
                this.form.auditFlowItems = resp.data.auditFlowItems;
                callback();
            });
        },
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    // 移除掉 "menU_UNT":"ADD" 的物件（申請人)
                    this.form.auditFlowItems = this.form.auditFlowItems.filter((x) => !!x.rolE_TYP);

                    console.log('SpecialProject upsert', this.form);
                    this.$api({
                        url: 'SpecialProjectManagementPage/UpsertProject',
                        method: 'POST',
                        data: this.form,
                    }).then(() => {
                        this.$router.push({
                            name: 'special-disbursement-project',
                        });
                    });
                } else {
                    this.scrollViewToError();
                }
            });
        },
        scrollViewToError() {
            setTimeout(() => {
                const isError = document.getElementsByClassName('is-error');
                if (isError.length > 0) {
                    isError[0].scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 100);
        },
        addFlowMember(index) {
            this.form.auditFlowItems.splice(index, 0, {
                elsE_STF_SNO: null,
                menU_UNT: '',
                rolE_TYP: 0,
                sno: null,
                sot: 0,
                typ: 0,
            });
        },
        handleMemberSelect(value, index) {
            const [d0, d1, d2] = value.split('/');
            if (d0 === '1') {
                this.form.auditFlowItems[index].rolE_TYP = parseInt(d0, 10);
                this.form.auditFlowItems[index].menU_UNT = d1;
            } else if (d0 === '2') {
                this.form.auditFlowItems[index].rolE_TYP = parseInt(d0, 10);
                this.form.auditFlowItems[index].elsE_STF_SNO = parseInt(d1, 10);
                this.form.auditFlowItems[index].menU_UNT = d2;
            }
        },
        deleteItem(index) {
            this.form.auditFlowItems.splice(index, 1);
        },
        onCancel() {
            this.$router.push({ name: 'special-disbursement-project' });
        },
    },
};
</script>
<style lang="scss"></style>
